// extracted by css-extract-rspack-plugin
export default {"formField":"UiFormField_formField_YLd1A","label":"UiFormField_label_x6ahe","error":"UiFormField_error_K3VE8"};